export const ACTIONS = {
  TOGGLED_GROUP_CHAT: 'TOGGLED_GROUP_CHAT',
  RESET_GROUP_CHAT: 'RESET_GROUP_CHAT',
};

export const toggleGroupChatState = value => ({
  type: ACTIONS.TOGGLED_GROUP_CHAT,
  payload: value,
});
